/* eslint-disable array-callback-return */
import React from "react";
import { useSelector } from "react-redux";
const ICHValueCellRenderer = (props) => {
  const data = props.data;
  let { deatilspagecontentseparate } = useSelector((store) => store.template);
  let formattedICHCode = "";
  let formattedICHCodeString = "";
  if (data.ichcode !== null) {
    let replaceICHCodeValue = data.ichcode.includes(`\n`)
      ? data.ichcode.replaceAll(`\n`, `\\n`)
      : data.ichcode;
    let splitedValues = replaceICHCodeValue.split(`\\n`);
    if (splitedValues.length !== 0) {
      splitedValues.map((code, index) => {
        if (code !== "") {
          formattedICHCode =
            code !== ""
              ? `${formattedICHCode}${code} ${
                  index === splitedValues.length - 1 ? "" : "\n"
                }`
              : "";
          formattedICHCodeString =
            code !== ""
              ? `${formattedICHCodeString}${code} ${
                  index === splitedValues.length - 1
                    ? "  "
                    : deatilspagecontentseparate
                }`
              : "";
        }
      });
    }
  } else {
    formattedICHCode = data.ichcode;
    formattedICHCodeString = data.ichcode;
  }
  return (
    <div className="custom-tooltip" title={formattedICHCode}>
      {formattedICHCodeString || formattedICHCodeString === 0
        ? formattedICHCodeString
        : "--"}
    </div>
  );
};
export default ICHValueCellRenderer;
